import React, { memo } from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function PDSection() {
  return <div className="bg-gradient-to-b from-dark-800 to-dark-900 pb-4 md:pb-10" data-id="element-172">
      <Section data-id="element-173">
        <div className="max-w-4xl mx-auto" data-id="element-174">
          <div className="border-t border-dark-700 pt-6 md:pt-12 text-center" data-id="element-175">
            <h3 className="text-2xl font-serif text-cream-100 mb-4 md:mb-6" data-id="element-176">
              P.D.
            </h3>
            <p className="text-base md:text-lg text-cream-200 font-serif italic mb-4 md:mb-8" data-id="element-177">
              Un país puede perder dinero. Puede perder infraestructura. Puede
              perder generaciones.
            </p>
            <p className="text-base md:text-lg text-cream-200 font-serif italic mb-4 md:mb-8" data-id="element-178">
              Pero si conserva memoria estructurada…
              <br data-id="element-179" />
              <span className="text-gold-400 font-bold not-italic" data-id="element-180">
                todavía puede reconstruirse.
              </span>
            </p>
            <p className="text-lg md:text-xl text-cream-100 font-serif font-bold mb-4 md:mb-8" data-id="element-181">
              No dejes que lo expliquen por ti.
            </p>

            <motion.a href="#pricing-cta" onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            const target = document.getElementById('pricing-cta');
            if (target) {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="relative inline-flex items-center justify-center px-8 py-3 text-lg font-bold tracking-wide transition-all duration-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark-900 shadow-[0_0_20px_rgba(220,38,38,0.3)] hover:shadow-[0_0_30px_rgba(220,38,38,0.5)] cursor-pointer" style={{
            backgroundColor: '#dc2626',
            color: '#ffffff'
          }} data-id="element-182">
              Comprar Ahora - $9.97
            </motion.a>
          </div>
        </div>
      </Section>
    </div>;
}